<!-- @format -->

<ng-container *transloco="let t">
  <sis-study-box
    [id]="customCourseUnitAttainment?.id"
    [name]="customCourseUnitAttainment?.name"
    [gradeScaleId]="customCourseUnitAttainment?.gradeScaleId"
    [gradeId]="customCourseUnitAttainment?.gradeId"
    [code]="customCourseUnitAttainment?.code"
    [attainedCredits]="customCourseUnitAttainment?.credits"
    [type]="studyBoxType"
    [credits]="visibleCredits"
    [level]="headingLevel"
    [action]="action"
    [selected]="selected"
    [nameClickable]="nameClickable"
    (actionChange)="actionChange.emit($event)"
    (nameClickAction)="openCustomCourseUnitAttainmentInfoModal()">
    <ng-container study-box="notifications">
      @if (
        customCourseUnitAttainmentStateObject?.invalidSelection && !this.customCourseUnitAttainmentStateObject?.hasModuleContentApproval
      ) {
        <sis-study-notification-box type="alert">{{ t("SIS_COMPONENTS.STUDY.INVALID_SELECTION") }}</sis-study-notification-box>
      }
      @if (customCourseUnitAttainmentStateObject?.isInvalidAccordingToModuleContentApprovalRequested) {
        <sis-study-notification-box type="alert">{{
          t("SIS_COMPONENTS.STUDY.INVALID_ACCORDING_TO_MODULE_CONTENT_APPROVAL")
        }}</sis-study-notification-box>
      }
      @if (customCourseUnitAttainmentStateObject?.isInvalidAccordingToModuleContentApprovalAccepted) {
        <sis-study-notification-box type="alert">{{ t("SIS_COMPONENTS.STUDY.CONTENT_NOT_AS_APPROVED") }}</sis-study-notification-box>
      }
      @if (customCourseUnitAttainmentStateObject?.isAttainmentAboutToExpire) {
        <sis-study-notification-box type="info">{{
          t("SIS_COMPONENTS.STUDY.EXPIRATION_IMMINENT", {
            expiryDate: customCourseUnitAttainmentStateObject.attainmentExpiryDate | localDateFormat,
          })
        }}</sis-study-notification-box>
      }
      <sis-custom-course-unit-attainment-details-box
        [customCourseUnitAttainment]="customCourseUnitAttainment"></sis-custom-course-unit-attainment-details-box>
    </ng-container>
  </sis-study-box>
</ng-container>
